var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 12.0003C26.3335 10.442 27.6085 9.16699 29.1668 9.16699V3.50033C29.1668 1.94199 27.8918 0.666992 26.3335 0.666992H3.66683C2.1085 0.666992 0.847663 1.94199 0.847663 3.50033V9.16699C2.406 9.16699 3.66683 10.442 3.66683 12.0003C3.66683 13.5587 2.406 14.8337 0.833496 14.8337V20.5003C0.833496 22.0587 2.1085 23.3337 3.66683 23.3337H26.3335C27.8918 23.3337 29.1668 22.0587 29.1668 20.5003V14.8337C27.6085 14.8337 26.3335 13.5587 26.3335 12.0003ZM20.0718 18.8003L15.0002 15.542L9.9285 18.8003L11.4585 12.9637L6.79766 9.15282L12.8043 8.79866L15.0002 3.21699L17.1818 8.81282L23.1885 9.16699L18.5277 12.9778L20.0718 18.8003Z",
    fill: "#223E7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.ae392f3b173beddf3a322a563e0c462b.svg";
export { ForwardRef as ReactComponent };